import { Button, Card, Flex, Icon, Spinner, Text } from '@wyz/ui';
import { Trans } from '~/common/context';
import { Link } from 'react-router';
import { useManageServiceQuoteCart } from '~/purchase/api';

function ServiceQuoteCartStatus() {
  const cart = useManageServiceQuoteCart({ get: { enabled: true } });
  const isCartFetched = cart.get.isSuccess && cart.get.isFetched;
  const serviceCount = cart.get.data?.data.services.length ?? 0;

  return (
    <Flex className='space-x-1'>
      <Card className='rounded-1'>
        <Card.Body className='py-0 px-1 fw-semi-bold'>
          <div className='fs-xxs'>
            <Trans i18nKey='app.purchase.quote_cart_page.in_your_quote' />
          </div>
          {isCartFetched && serviceCount ? (
            <Text color='secondary' heading='xs' id='cart-items-count'>
              <Trans
                i18nKey='app.purchase.service_quote.count'
                values={{ serviceCount: serviceCount }}
              />
            </Text>
          ) : cart.get.isProcessing ? undefined : (
            <div className='fs-xs text-title-color' data-cy='cart-items-count'>
              <Trans i18nKey='app.purchase.empty_cart' />
            </div>
          )}
        </Card.Body>
      </Card>
      <Button
        id='check-service-quote-cart'
        variant='primary'
        size='md'
        as={Link}
        to='cart'
      >
        {cart.get.isProcessing ? (
          <Spinner style={{ width: 20, height: 20 }} />
        ) : (
          <div className='position-relative'>
            <Icon icon='clip-board' size='xs' />
            {Boolean(serviceCount) && (
              <div
                className='position-absolute bg-blue-secondary rounded-circle'
                style={{
                  left: '100%',
                  top: 0,
                  width: '0.475rem',
                  height: '0.475rem',
                }}
              ></div>
            )}
          </div>
        )}
      </Button>
    </Flex>
  );
}

export default ServiceQuoteCartStatus;
